import { RouterProvider } from 'react-router-dom';
import { App as AntdApp } from 'antd';
import { router } from './router';

function App() {
  // 认证初始化已移至 AuthInitializer 组件中
  // 在 ProtectedRoute 内的页面访问时会先完成 me 请求获取权限
  return (
    <AntdApp message={{ duration: 5, maxCount: 3 }}>
      <RouterProvider router={router} />
    </AntdApp>
  );
}

export default App;
